export interface AssetGroup {
      Id: string;
      AssetGroupName: string;
      PartitionKey?: string;
      ClientKey?: string;
}